import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';
import { HttpParams } from '@angular/common/http';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';
import { Permission } from 'src/app/shared/models/security/permission';

@Injectable({
	providedIn: 'root'
})
export class PermissionService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllPermissions(): Observable<Permission[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.permissionUrl}/all`,
			'getAllPermissions'
		);
	}

	addPermission(permission: Permission): Observable<number> {
		console.log(permission);
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.permissionUrl}/add`,
			`addPermission`,
			permission
		);
	}

	updatePermission(permission: Permission): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.permissionUrl}/update/${permission.id}`,
			`updatePermission`,
			permission
		);
	}

	deleteRole(roleId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.permissionUrl}/${roleId}`,
			`deleteRole`
		);
	}

	getRolesMinimal(): Observable<Permission[]> {
		let queryParams = new HttpParams().append('light', true);
		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.permissionUrl}/all`,
			'getAllRoles',
			httpOptions
		);
	}

	getRoleById(roleId: number): Observable<Permission> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.permissionUrl}/get/${roleId}`,
			'getRoleById'
		);
	}

	getRolesPageable(
		page: number,
		size: number,
		search: string,
	): Observable<ListingResponse> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('page', page);
		queryParams = queryParams.append('size', size);
		if (search) {
			queryParams = queryParams.append('search', search);
		}

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.permissionUrl}`,
			'getRoles',
			//httpOptions
		);
	}
}
